import { combineReducers } from 'redux';

import dns from './dns/dnsReducer';

export default combineReducers({
	dns,
});
